import { render } from "./NavLink.vue?vue&type=template&id=5a74d795&scoped=true&ts=true"
import script from "./NavLink.vue?vue&type=script&lang=ts"
export * from "./NavLink.vue?vue&type=script&lang=ts"

import "./NavLink.vue?vue&type=style&index=0&id=5a74d795&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a74d795"]])

export default __exports__